/**
 * useTranscriptionSettings — reads transcription plugin settings from localStorage.
 * Returns reactive values for each registered setting.
 */

import type { Accessor } from 'solid-js'
import { useLocalStorage } from '../../../data/utils-data'

export interface TranscriptionSettings {
  /** When true, raw applog metadata (timestamps, IDs, channel dominance) is shown (debug mode) */
  showRawApplogs: Accessor<boolean>
}

const SETTING_PREFIX = 'note3.plugins.transcriptions'

export function useTranscriptionSettings(): TranscriptionSettings {
  const [showRawApplogs] = useLocalStorage<boolean>(
    `${SETTING_PREFIX}.showRawApplogs`,
    false,
  )

  return { showRawApplogs }
}
